import React from "react"
import PropTypes from "prop-types"
import Link from "components/elements/link"
import "./clinicTextImage.scss"

/**
 * Optional text + image block from the locations redesign.
 *
 * Alternating layout: `reverse` puts the image on the right instead of the
 * left. Intended to be driven by Contentful's Split Content section once
 * centres start adding these; today it renders the design's placeholder copy
 * so the layout can be reviewed.
 */
const ClinicTextImage = ({ body, ctaHref, ctaText, image, reverse, title }) => (
  <section
    className={`ClinicTextImage${reverse ? " ClinicTextImage--reverse" : ""}${
      image?.src ? "" : " ClinicTextImage--no-image"
    }`}
  >
    {/* container-v2 keeps this in line with the sections above */}
    <div className="container-v2 ClinicTextImage__inner">
      {image?.src && (
        <div className="ClinicTextImage__media">
          <img
            alt={image.alt}
            className="ClinicTextImage__image"
            src={image.src}
          />
        </div>
      )}

      <div className="ClinicTextImage__content">
        <h2 className="ClinicTextImage__title">{title}</h2>
        <p className="ClinicTextImage__body">{body}</p>
        {ctaText && (
          <Link className="ClinicTextImage__cta" to={ctaHref}>
            {ctaText}
          </Link>
        )}
      </div>
    </div>
  </section>
)

ClinicTextImage.defaultProps = {
  ctaHref: "#",
  reverse: false,
}

ClinicTextImage.propTypes = {
  body: PropTypes.string,
  ctaHref: PropTypes.string,
  ctaText: PropTypes.string,
  image: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string,
  }),
  reverse: PropTypes.bool,
  title: PropTypes.string,
}

export default ClinicTextImage
